function Four() {
    return (
        <div className="flex w-full bg-[#f9f9f9] p-2 rounded-sm items-center flex-col md:flex-row" id='promise4'> {/* Added bg-gray-100 for a light gray background */}
                <div className="hidden md:block w-full md:w-4/12"> {/* Added full width for consistency */}
                <div className="promise-image-column w-full p-4">
                    <img src="/halo-promise/4.png" alt="24/7 Toll-Free Holiday Hotline" className="w-full h-auto object-contain" />
                </div>
            </div>
            <div className="benefits-divider w-1/12 bg-gray-300 min-h-full"></div> {/* Ensured divider reaches full height */}
            <div className="benefits-details w-full md:w-7/12 p-4"> {/* Added padding for better content spacing */}
                <h2 className="text-lg md:text-xl font-bold mb-6 mt-4 text-black leading-tight inline-block relative">
                    <span className="relative z-10">Flexible Accommodation Cancellation: We’ve Got Your Back</span>
                    <span className="absolute -bottom-2 left-0 h-1 rounded-md w-[50%] bg-gradient-custom -z-0"></span>
                </h2>

                <p className="text-sm text-black mb-4">Plans change—that’s life. Our <span className="text-halo-pink">Flexible Cancellation Options</span> give you peace of mind, allowing you to make adjustments or cancellations if necessary.</p>

                <p className="text-sm text-black mb-4">From sudden schedule changes to unexpected events, we ensure you’re never left stranded.</p>

                <h3 className="text-lg font-semibold mb-4 mt-4">Why You'll Love This</h3>
                <ul className="custom-bullet pl-5 space-y-2 text-black text-sm">
                    <li><span className="font-medium text-black">Total Flexibility</span> – Easily modify or cancel if things don’t go as planned.</li>
                    <li><span className="font-medium text-black">Hassle-Free Refunds</span> – We process cancellations swiftly to get you your money back.</li>
                    <li><span className="font-medium text-black">Confidence in Booking</span> – Plan with confidence, knowing you’re covered.</li>
                </ul>

                <div className="bg-white rounded-lg p-4 mt-4"> {/* New container with background */}
                    <div className="flex items-center">
                        <img src="/featureIcons/promise1.svg" alt="halo-promise" className="w-6 h-6 mr-2" />
                        <h3 className="text-lg font-semibold">Our Promise</h3>
                    </div>
                    <p className="text-black mt-2">Freedom to change, cancel, or adjust your trip without the usual stress, so you can book confidently.</p>
                </div>
            </div>

        </div>
    );
}

export default Four;